import React from "react";
import { Route, Redirect } from "react-router-dom";

const ProtectedRoute = ({ component: Component, loggedUser, ...rest }) => {
    return (
    <Route {...rest} render={
      (props) => {
        if (loggedUser) {
         // return <Component {...rest} {...props} />;
         const signInUserSession = localStorage.getItem("signInUserSession_Domain");
         if(signInUserSession==="CHEP-DEV")
         {
          localStorage.setItem("signInUserSession_Domain", "CHEP-DEV");
           return <Component {...rest} {...props} />;
         }
         else{
           return <Redirect to="/" />;
         }
        } else {
          return <Redirect to="/" />;
        }
      }
    } />
  );
};

export default ProtectedRoute;